var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBottomDeleteAll(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 2h6",
    stroke: "#7D8085",
    strokeWidth: 1.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1 5.1H15V3.9H1v1.2h1.9v8.1a1.4 1.4 0 001.4 1.4h7.4a1.4 1.4 0 001.4-1.4V5.1zm-1.2 0H4.1v8.1c0 .11.09.2.2.2h7.4a.2.2 0 00.2-.2V5.1zM7.151 9L5.576 7.424l.848-.848L8 8.152l1.576-1.576.848.848L8.85 9l1.575 1.576-.848.848L8 9.85l-1.576 1.575-.848-.848L7.15 9z",
    fill: "#7D8085"
  })));
}
export default __webpack_public_path__ + "static/bottom-delete-all.bef36343.svg";
export { SvgBottomDeleteAll as ReactComponent };